<div class="vl-autocomplete js-vl-autocomplete">
    <span v-vl-visually-hidden v-html="helpText"></span>
    <vl-input-field
            :id="inputFieldId"
            ref="inputFieldRef"
            :modelValue="searchText"
            autocomplete="off"
            v-bind="$attrs"
            @focus="showResults"
            @update:modelValue="updateModelValue"
            @keydown.tab="hideResults"
            @keyup.esc="hideResults"
            @keydown.enter="selectFocussedResult"
            @keyup.down="arrowDown"
            @keyup.up="arrowUp"/>
    <div v-if="feedback" class="vl-autocomplete">
        <div class="vl-autocomplete__feedback" v-html="feedback"></div>
    </div>
    <div v-if="fetching" class="vl-autocomplete__loader">
        <vl-loader></vl-loader>
    </div>
    <div v-if="hasResults"
         v-show="resultsVisible"
         :aria-hidden="!hasResults.toString()"
         :data-vl-show="hasResults.toString()"
         class="vl-autocomplete"
         data-vl-content="">
        <div class="vl-autocomplete__list_wrapper">
            <ul class="vl-autocomplete__list" data-vl-records="" role="listbox">
                <li v-for="(result, index) in results"
                    :key="result.value.name + '_' + index"
                    class="vl-autocomplete__item"
                    role="option">
                    <a :class="{'vl-autocomplete__cta': true, 'vl-autocomplete__cta--focus': result.selected}"
                       :data-vl-index="index + 1"
                       :data-vl-value="result.value.name"
                       data-vl-focus=""
                       data-vl-record=""
                       href="#"
                       tabindex="-1"
                       @click.prevent="select(result)">
                        <span class="vl-autocomplete__cta__title" v-html="result.title"></span>
                        <span v-if="result.subtitle" class="vl-autocomplete__cta__sub">{{ result.subtitle }}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>